import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.sass']
})
export class HomepageComponent implements OnInit {


  public title: string = 'zwalker.net'
  public titleArray: Array<string> = Array.from(this.title.toLowerCase())
  
  constructor() { }

  ngOnInit() {
  }

}
